<template>
  <v-select
    v-model="item"
    dir="rtl"
    :multiple="multiple"
    :clearable="clearable"
    label="Title"
    :reduce="x => x.Id"
    :options="items"
    :loading="loading"
    :selectable="x => unselectable.includes(x.Id) === false || x === val"
    @open="onOpen"
    @option:selected="$emit('selected')"
  >
    <span
      slot="no-options"
      @click="$refs.select.open = false"
    >
      {{ $t('common.noOptions') }}
    </span>
    <template #spinner>
      <div class="demo-inline-spacing">
        <b-spinner
          v-if="loading"
          class="m-0"
          small
          variant="secondary"
        />
      </div>
    </template>
  </v-select>
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'ZCampaign',
  props: {
    value: {
      type: [String, Number, Array],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    unselectable: {
      type: Array,
      default: () => [],
    },
    autoFetch: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selected: null,
      val: this.value,
      loading: false,
    }
  },
  watch: {
    value(v) {
      this.val = v
    },
    autoFetch: {
      immediate: true,
      handler(val) {
        if (val) this.get()
      }
    }
  },
  computed: {
    ...mapState('zirehState', { items: state => state.campaignSelect }),
    ...mapState('zirehState', { flag: state => state.campaignSelectFlag }),
    item: {
      get() {
        if (this.value && (this.value.length || this.multiple === false)) {
          this.get()
        }
        return this.val
      },
      set(newValue) {
        this.$emit('input', newValue)
        this.val = newValue
      },
    },
  },
  methods: {
    get() {
      if (this.flag === false && this.items.length === 0) {
        this.$store.commit('zirehState/setCampaignSelectFlag', true)
        this.loading = true
        this.$http.get(this.$api.campaigns.getAll)
            .then(res => {
              this.$store.commit('zirehState/setCampaignSelect', res.data)
              this.loading = false
            })
      }
    },
    onOpen() {
      this.get()
    },
  },
}
</script>
